import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ValueProps.module.scss';

const valueKeys = ['control', 'simplicity', 'reliability', 'openness'] as const;

export const ValueProps: React.FC = () => {
  const { t } = useTranslation('home');

  return (
    <section className={styles.section}>
      <p className={styles.pitch}>{t('pitch')}</p>
      <div className={styles.grid}>
        {valueKeys.map((key) => (
          <div key={key} className={styles.card}>
            <h3 className={styles.title}>{t(`values.${key}.title`)}</h3>
            <p className={styles.description}>{t(`values.${key}.description`)}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
